import { DIFFERENCE_CONSTANTS } from "./constants";
import { Box, Heading, SimpleGrid } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import bgImage from "public/openStack/diffrenceBG.png";
import { AdvantageCard } from "../advantages/card";
const DifferenceComponent = () => {
  return (
    <Box backgroundImage={bgImage.src} backgroundSize="cover" pb={20}>
      <PageLayout>
        <Box>
          <Heading
            as="h2"
            fontWeight={"400"}
            textAlign={"center"}
            fontSize={"40px"}
            color="white"
            mb={4}
          >
            What Makes Us Different?
          </Heading>
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={12} width={"100%"}>
            {DIFFERENCE_CONSTANTS.map((item, index) => (
              <AdvantageCard
                key={index}
                text={item.text}
                image={item.image}
                title={item.title}
                textColor={"white"}
                headingColor={"white"}
              />
            ))}
          </SimpleGrid>
        </Box>
      </PageLayout>
    </Box>
  );
};

export default DifferenceComponent;
